import { css } from "styled-components";
import * as styles from '../styles/_mediaqueries.scss';

interface Size {
  phone: number
  tablet: number
  desktop: number
  largedesktop: number
}

const sizes: Size = {
  phone: styles.phone,
  tablet: styles.tablet,
  desktop: styles.desktop,
  largedesktop: styles.largedesktop
}
// iterate through the sizes and create a media template

export const media = Object.keys(sizes).reduce((accumulator: any, label: keyof Size) => {
  // use em in breakpoints to work properly cross-browser and support users
  // changing their browsers font-size: https://zellwk.com/blog/media-query-units/
  accumulator[label] = (...args: any[]) => css`
    @media (max-width: ${sizes[label]}) {
      ${css(args as any)}
    }
  `
  return accumulator
}, {})

export default media;


// WEBPACK FOOTER //
// ./src/helpers/mediaqueries.ts